import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const CustomNoRowsOverlay: React.FC<{ message: string }> = ({ message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'text.secondary',
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography variant="h6">{message}</Typography>
    </Box>
  );
};

export default CustomNoRowsOverlay; 